export const GITHUB_TOKEN = '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'
export const DEVICE_MANAGER_URL = 'wss://jetson-manager.realsoft.ai/jetson_device_manager/'
